import * as actions from "../action.constants";

const requestWebhooks = (pageUrl) => ({
  type: actions.REQUEST_WEBHOOKS,
  pageUrl,
});

const saveWebhooks = (data) => ({
  type: actions.SAVE_WEBHOOKS,
  payload: data,
});

const createUpdateWebHook = (data, callback) => ({
  type: actions.CREATE_UPDATE_WEBHOOK,
  payload: data,
  callback,
});

const deleteWebhook = (id, callback) => ({
  type: actions.DELETE_WEBHOOK,
  payload: id,
  callback,
});

const requestWebhookDeliveryLogs = (webhookId, pageUrl) => ({
  type: actions.REQUEST_WEBHOOK_DELIVERY_LOGS,
  pageUrl,
  webhookId,
});

const saveWebhookDeliveryLogs = (data) => ({
  type: actions.SAVE_WEBHOOK_DELIVERY_LOGS,
  payload: data,
});

export {
  requestWebhooks,
  saveWebhooks,
  createUpdateWebHook,
  deleteWebhook,
  requestWebhookDeliveryLogs,
  saveWebhookDeliveryLogs,
};
